import { Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {DatepickerFormComponent} from './datepicker-form.component';
import * as moment_ from 'moment';
const moment = moment_;
import {DatepickerConfig} from './datepicker.config';
import {DatepickerComponent} from './datepicker.component';

@Component({
  selector: 'hxa-datepicker-interval',
  template: `<div class="hx-datepicker-set-interval is-flex hx-flex-justify-between hx-flex-column">

  <div class="hx-datepicker-set-interval-content is-flex hx-flex-column hx-flex-auto hx-flex-align-center hx-flex-justify-center  pa-3">


      <div class="mb-5">
        <div class="hx-datepicker-set-interval-number mr-5">
          <input type="number" id="numberText" class="hx-input" min=1  [(ngModel)]="dropdownNumber" (change)="onSelect()" #numberText>
        </div>

        <span class="hx-dropdown month mr-5" hxaDropdown>
          <select id="durationText" class= "hx-input"  (change)="onSelect()" [(ngModel)]="Duration" #durationText>
            <option>day(s)</option>
            <option>week(s)</option>
            <option>month(s)</option>
            <option>year(s)</option>
          </select>
        </span>

        <span><small>from</small> <span class="hx-datepicker-set-interval-today ml-2">today</span></span>
      </div>

      <div class="mb-3">
        <span><small>will be</small></span>
        <span class="hx-datepicker-set-interval-selected-date ml-1">
        {{ _DueDate }}
        </span>
      </div>

  </div>

  <div class="hx-datepicker-set-interval-footer pa-3">
    <div class="hx-columns">
      <div class="hx-column">
        <button class="hx-button" (click)="onCancel()">Cancel</button>
      </div>
      <div class="hx-column is-text-right">
        <button class="hx-button is-primary" (click)="onChoose()">Select</button>
      </div>
    </div>
  </div>

</div>
`,
  styles: [`.hx-datepicker-set-interval{max-width:19rem;width:19rem;height:13.86rem;background-color:#fff}.hx-datepicker-set-interval .hx-datepicker-set-interval-content .hx-datepicker-set-interval-number{width:2.5rem;display:inline-block}.hx-datepicker-set-interval .hx-datepicker-set-interval-content .hx-datepicker-set-interval-today{font-size:1rem}.hx-datepicker-set-interval .hx-datepicker-set-interval-content .hx-datepicker-set-interval-selected-date{font-size:1.1rem;font-weight:500}.hx-datepicker-set-interval .hx-datepicker-set-interval-footer{flex:0 0 auto;background-color:rgba(0,0,0,.04)}`]
})
export class DatepickerIntervalComponent implements OnInit {

  @ViewChild('durationText') durationText: ElementRef;
  @ViewChild('numberText') numberText: ElementRef;
  protected close: Function;
  public Duration: any ; // = 'day(s)';
  public dropdownNumber: any ; // = 0;
  public text: any ; // =  moment().add(this.dropdownNumber , this.Duration);
  public _DueDate: string ;
  public _dueDatestring: string;
  public durationText1: any;
  public numberText1: any;
  public selectedDuration: string;
  private presentDate: Date;
  viewDate: Date;

  @Input()
  selectedDateInterval: Date;

  @Input()
  placement: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  constructor(private _datepickerForm: DatepickerFormComponent, private datePickerConfig: DatepickerConfig,
    private _datepickerComponent: DatepickerComponent) {
     }

  ngOnInit() {
    const selectedDueDateInterval = this.datePickerConfig.selectedDueDateInterval === undefined ?
     (this._datepickerComponent.selectedDueDateInterval ? this._datepickerComponent.selectedDueDateInterval.split(' ') : undefined) :
      this.datePickerConfig.selectedDueDateInterval.split(' ');
    if (selectedDueDateInterval && selectedDueDateInterval.length > 1) {
      this.dropdownNumber = selectedDueDateInterval[0];
      this.Duration = this.resetDurationText(selectedDueDateInterval[1]);
      if (this.datePickerConfig && this.datePickerConfig.tabSelected === 'tab1') {
        this.durationText1 = this.SelectElement(this.durationText, this.Duration);
        this.numberText1 = this.SelectElement(this.numberText, this.dropdownNumber);
        this._DueDate = this.onSelectoptions(this.numberText1, this.durationText1);
      } else if (this.datePickerConfig && this.datePickerConfig.tabSelected === 'tab2') {
        this.text = moment().add(this.dropdownNumber, this.Duration.replace('(s)', 's'));
        this._DueDate = (this.text).format('ddd DD/MM/YYYY');
      }
    }
  }

  onCancel = () => {
    this._datepickerComponent.OpenDiv = false;
  }
  onSelect = () => {
    if (this.dropdownNumber && this.Duration) {
      this.text = moment().add(this.dropdownNumber , this.Duration.replace('(s)', 's'));
      this._DueDate = (this.text).format('ddd DD/MM/YYYY');
      this._dueDatestring = (this.text).format('DD/MM/YYYY');
      const date: Date = this.text ? new Date( this.text) : new Date();
      this.presentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this._datepickerComponent.viewDate =  new Date(date.getFullYear(), date.getMonth());
      this._datepickerComponent.renderCalendar();
      this._datepickerForm.dueDateInterval = this.dropdownNumber + ' ' + this.Duration;
      this._datepickerForm.onChange(this._dueDatestring);
     return this._DueDate;
     }
  }
  onSelectoptions(numbervalue , durationValue) {
      this.text = moment().add(numbervalue , durationValue.replace('(s)', 's'));
      this._DueDate = (this.text).format('ddd DD/MM/YYYY');
      this._dueDatestring = (this.text).format('DD/MM/YYYY');
      this._datepickerForm.onChange(this._dueDatestring);

      return this._DueDate;
  }
  public onChoose() {
    this._datepickerForm.date =  new Date(this.text);
    this._datepickerForm.setDate(new Date(this.text));
    this._datepickerComponent.OpenDiv = false;
    this._datepickerForm.onChange(this._dueDatestring);
    this._datepickerComponent.selectedDueDateInterval = undefined;
    this._datepickerForm.dueDateInterval = this.dropdownNumber + ' ' + this.Duration;
  }

  public SelectElement(id , valueToSelect) {
    (id.nativeElement).value = valueToSelect;
    return ((id.nativeElement).value);
  }
  public resetDurationText(duration: string): string {
    if (duration === 'day' || duration === 'week' || duration === 'month' || duration === 'year') {
      return duration + '(s)';
    } else if (duration === 'days' || duration === 'weeks' || duration === 'months' || duration === 'years') {
      return duration.replace('s', '(s)');
    } else {
      return duration;
    }
  }
}
